import { useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface AirlineListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
    name?: string;
    code?: string;
}

const defaultFilters: AirlineListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "name",
    sortOrder: "asc",
    name: "",
    code: ""
};

export const useAirlineListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<AirlineListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<AirlineListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    const setSort = (sort: ListTableSort) => {
        saveAndSetFilters({ sortBy: sort.by, sortOrder: sort.order, page: 1 });
    };

    const setPage = (page: number) => {
        saveAndSetFilters({ page });
    };

    const setPageSize = (pageSize: number): void => {
        saveAndSetFilters({ pageSize, page: 1 });
    };

    const setName = (name?: string): void => {
        saveAndSetFilters({ name, page: 1 });
    };

    const setCode = (code?: string): void => {
        saveAndSetFilters({ code, page: 1 });
    };

    const clearFilters = (): void => {
        saveAndSetFilters(defaultFilters);
    };

    const saveAndSetFilters = (newFilters: Partial<AirlineListingFilters>): void => {
        setFilters((prevFilters: AirlineListingFilters) => {
            const updatedFilters = { ...prevFilters, ...newFilters };

            filtersService.saveFilters(location.pathname, history, updatedFilters);

            return updatedFilters;
        });
    };

    return {
        filters,
        setCode,
        setName,
        setPage,
        setPageSize,
        setSort,
        clearFilters
    };
};
